const PAGES = [];

export default PAGES;
